export { default } from './components/StarRatingMeter';



// WEBPACK FOOTER //
// ./src/index.js